const paymentAmountTypes = {
  PARTIAL: 'partial',
  FULL: 'full',
};

export default paymentAmountTypes;
